<template>
  <div class="card "> <!--Document -->
    <div class="card-header">
      <h3 class="cart-title">
        <a data-action="collapse">Documents</a>
      </h3>
      <div class="heading-elements">
        <ul class="list-inline mb-0">
          <li>
            <a
              v-b-toggle="`collapseFileCard`"
              data-action="collapse"
            ><i data-feather="chevron-down" /></a>
          </li>
        </ul>
      </div>
    </div>
    <b-collapse
      :id="`collapseFileCard`"
      visible
    >
      <div class="card-body">
        <b-tabs>
          <b-tab
            :active="activeTab == 0"
            @click="activeTab = 0"
          >
            <template #title>
              Upload docs
            </template>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, ipsa consectetur sint nostrum placeat corrupti explicabo deleniti dolores voluptate distinctio dolor alias dolore, eius dignissimos pariatur in, debitis non iusto.</p>
            <div
              v-if="status != 0"
              :class="`alert alert-${statusType} w-25 p-1`"
            >
              <div class="row">
                <div class="col-1">
                  <div
                    v-if="status == 1"
                    class="loading custom-loading"
                  >
                    <div class="effect-1 effects" />
                    <div class="effect-2 effects" />
                    <div class="effect-3 effects" />
                  </div>
                  <i
                    v-if="status == 2"
                    data-feather="check"
                  />
                  <i
                    v-if="status == 3"
                    data-feather="x"
                  />
                </div>
                <div class="col-11 center-vertically">
                  <span v-if="status == 1">
                    Checking if the files are correct...
                  </span>
                  <span v-if="status == 2">
                    File matches correctly found!
                  </span>
                  <span v-if="status == 3">
                    These files didn't match with any user: <strong v-html="errorFiles" />
                  </span>
                </div>
              </div>
            </div>
            <div class="card-header d-flex align-items-center justify-content-between">
              <div>
                <h4><strong>{{ data.length }}</strong> documents</h4>
              </div>
            </div>
            <div class="table-responsive-sm overflow-scroll">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Title</th>
                    <!-- <th>Follow</th> -->
                    <th>Need feedback</th>
                    <th>Deadline</th>
                    <th>Year</th>
                    <th>Renew</th>
                    <th>Archived date</th>
                    <th class="text-end">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="file, index in data"
                    :key="file.id"
                  >
                    <td>{{ file.title ? file.title : 'Multiple files' }}</td>
                    <!-- <td>
                      <div class="form-check form-check-success">
                        <input
                          id="colorCheck3"
                          v-model="file.follow"
                          type="checkbox"
                          class="form-check-input"
                          :checked="file.follow"
                        >
                      </div>
                    </td> -->
                    <td>
                      <div class="form-check form-check-success">
                        <input
                          id="colorCheck3"
                          v-model="file.need_feedback"
                          type="checkbox"
                          class="form-check-input"
                          :checked="file.need_feedback"
                        >
                      </div>
                    </td>
                    <td>
                      <date-picker
                        v-model="file.deadline"
                        format="YYYY-MM-DD HH:mm:ss"
                        value-type="format"
                      />
                    </td>
                    <td>
                      <date-picker
                        v-model="file.year"
                        format="Y"
                        type="year"
                        value-type="format"
                        class="w-100"
                      />
                    </td>
                    <td>
                      <date-picker
                        v-model="file.renew_year"
                        format="Y"
                        type="year"
                        value-type="format"
                        class="w-100"
                      />
                    </td>
                    <td>
                      <date-picker
                        v-model="file.archived_date"
                        format="YYYY-MM-DD HH:mm:ss"
                        value-type="format"
                      />
                    </td>
                    <td class="text-end">
                      <a
                        :href="file.url"
                        target="_blank"
                        class="btn btn-icon btn-icon rounded-circle btn-flat-dark me-1"
                      ><i data-feather="eye" /></a>
                      <a
                        class="btn btn-icon btn-icon rounded-circle btn-flat-danger"
                        data-bs-toggle="modal"
                        data-bs-target="#modalDeleteWithInput"
                        @click="deleteFile(file.id, index)"
                      ><i data-feather="trash-2" /></a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <hr>
              <div
                v-if="loggedUser.roles.includes('super-admin')"
                class="mb-1"
              >
                <div class="form-check form-check-success mb-2">
                  <input
                    id="sendCAE"
                    :checked="cae"
                    type="checkbox"
                    class="form-check-input"
                    @click="$emit('changeToCae', $event.target.checked)"
                  >
                  <label
                    class="form-check-label"
                    for="sendCAE"
                  >Send to CAE</label>
                </div>
              </div>
            </div>

            <div>
              <a
                v-b-toggle="`collapseFile`"
                class="btn btn-sm btn-dark dis-ib"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="collapseAddFile2"
              ><i data-feather="plus" /> Add file</a>

              <b-collapse
                :id="`collapseFile`"
                class="collapse mt-3"
              >
                <div class="card shadow-none bg-transparent border-secondary">
                  <div class="card-body">
                    <h3>Add file</h3>
                    <div class="row">
                      <div class="col">
                        <div class="mb-1">
                          <div
                            class="input-group custom-file-button"
                          >
                            <label
                              class="input-group-text"
                              for="inputGroupFile"
                            >Select file</label>
                            <input
                              id="formFile"
                              :ref="`file-new`"
                              class="form-control"
                              type="file"
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >Name</label>
                          <input
                            v-model="title"
                            type="text"
                            class="form-control"
                          >
                        </div>
                      </div>
                    </div>
                    <div class="mb-2">
                      <a
                        v-b-toggle="`collapseFile`"
                        class="btn btn-sm btn-outline-success me-1"
                        @click="uploadFile"
                      >Upload file</a>
                      <a
                        v-b-toggle="`collapseFile`"
                        class="btn btn-sm btn-flat-danger"
                      >Cancel</a>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </b-tab>

          <b-tab
            :active="activeTab == 1"
            @click="activeTab = 1"
          >
            <template #title>
              Upload massive docs
            </template>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, ipsa consectetur sint nostrum placeat corrupti explicabo deleniti dolores voluptate distinctio dolor alias dolore, eius dignissimos pariatur in, debitis non iusto.</p>
            <vue-dropzone
              id="dropzone"
              ref="myVueDropzone"
              class="dropzone-files"
              :options="dropzoneOptions"
              @vdropzone-files-added="sendingFile"
            />
            <hr>
            <!-- <div
              v-if="loggedUser.roles.includes('super-admin')"
              class="mb-1"
            >
              <div class="form-check form-check-success mb-2">
                <input
                  id="sendCAE"
                  :checked="cae"
                  type="checkbox"
                  class="form-check-input"
                  @click="$emit('changeToCae', $event.target.checked)"
                >
                <label
                  class="form-check-label"
                  for="sendCAE"
                >Send to CAE</label>
              </div>
            </div> -->
          </b-tab>
        </b-tabs>
      </div>
    </b-collapse>
  </div>
</template>
<script>
import Vue from 'vue'
import { BCollapse, BTab, BTabs } from 'bootstrap-vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import vue2Dropzone from 'vue2-dropzone'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { mapGetters } from 'vuex'

export default {
  components: {
    BCollapse,
    BTab,
    BTabs,
    vueDropzone: vue2Dropzone,
    DatePicker,
  },
  props: {
    data: { type: Array, required: false, default: () => [] },
    cae: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      title: '',
      activeTab: 0,
      status: 0,
      statusType: 'info',
      errorFiles: '',
      dropzoneOptions: {
        thumbnailWidth: 150,
        acceptedFiles: 'application/pdf',
        maxFilesize: 10,
        url: '#',
        uploadMultiple: true,
        headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` },
      },
    }
  },
  computed: {
    ...mapGetters({
      loggedUser: 'auth/admin',
    }),
  },
  mounted() {
    setTimeout(() => {
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 1000)
  },
  methods: {
    uploadFile() {
      const file = this.$refs['file-new'].files[0]
      if (file) {
        this.data.push({
          title: this.title,
          file,
          follow: true,
          url: URL.createObjectURL(file),
        })

        this.$emit('saveFiles', this.data)
        setTimeout(() => {
          feather.replace({
            width: 14,
            height: 14,
          })
        }, 200)

        this.title = null
        this.$refs['file-new'].value = null
      } else {
        Vue.swal('Please, upload a file first!', '', 'warning')
      }
    },
    sendingFile(files) {
      this.data.push({
        files: Array.from(files).map(i => ({
          title: i.name,
          file: i,
          url: URL.createObjectURL(i),
        })),
      })

      this.$emit('saveFiles', this.data)
      this.$emit('multipleFilesTrigger', true)
      this.$toastr.success('', 'Files imported successfully, edit in "Upload Docs" tab!')

      this.checkForIdentifyMatches()

      setTimeout(() => {
        feather.replace({
          width: 14,
          height: 14,
        })
        this.activeTab = 0
      }, 500)
    },
    deleteFile(fileId, index) {
      if (fileId) {
        this.$store.dispatch('labourHazards/deleteFile', fileId)
      }

      this.data.splice(index, 1)
      Vue.swal('File deleted successfully!', '', 'success')
    },
    async checkForIdentifyMatches() {
      this.status = 1

      const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/labour-hazards/files/check-multiple-files`, { files_h: this.data }).catch(() => {
        this.status = 3
        this.statusType = 'danger'
      })

      const filesKo = []

      if (resp.status === 200) {
        resp.data.forEach(item => {
          if (item.files) {
            item.files.forEach(file => {
              if (!file.matched) {
                filesKo.push(file.title)
              }
            })
          }
        })

        if (filesKo.length > 0) {
          this.errorFiles = filesKo.join(', <br>')
          this.status = 3
          this.statusType = 'danger'
        } else {
          this.status = 2
          this.statusType = 'success'
        }
      } else {
        this.status = 3
        this.statusType = 'danger'
      }

      setTimeout(() => {
        feather.replace({
          width: 14,
          height: 14,
        })
      }, 500)
    },
  },

}
</script>
